/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Time_CpsInputs */

const en_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate Timing by CPS`)
};

const fr_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculer le minutage par CPS`)
};

const de_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timingberechnung mit CPS`)
};

const it_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola i tempi tramite CPS`)
};

const ru_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расчет времени выполнения по CPS`)
};

const es_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular tiempo por CPS`)
};

const zh_cn2_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按CPS计算时间`)
};

const ja_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPSによるタイミングの計算`)
};

const hi_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीपीएस द्वारा समय की गणना करें`)
};

const pt_pt2_context_menu_auto_time_cps = /** @type {(inputs: Context_Menu_Auto_Time_CpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular o tempo pelo CPS`)
};

/**
* | output |
* | --- |
* | "Calculate Timing by CPS" |
*
* @param {Context_Menu_Auto_Time_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_time_cps = /** @type {((inputs?: Context_Menu_Auto_Time_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Time_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_auto_time_cps(inputs)
	if (locale === "de") return de_context_menu_auto_time_cps(inputs)
	if (locale === "it") return it_context_menu_auto_time_cps(inputs)
	if (locale === "ru") return ru_context_menu_auto_time_cps(inputs)
	if (locale === "es") return es_context_menu_auto_time_cps(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_auto_time_cps(inputs)
	if (locale === "ja") return ja_context_menu_auto_time_cps(inputs)
	if (locale === "hi") return hi_context_menu_auto_time_cps(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_auto_time_cps(inputs)
	return en_context_menu_auto_time_cps(inputs)
});